module.exports = __webpack_public_path__ + "static/footer-5186b082b1b6d8928786387fb78295e9.jpg";